import actions from '../../actionTypes';

export default groups => {
  return {
    type: actions.SET_GROUPS,
    groups
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/setGroups.js